import React, { useEffect, useState } from 'react'
import classes from './scanPage.module.scss'
import { useNavigate } from 'react-router'
import Scan from '../../../Scan'
import ScanFinished from '../../../ScanFinished'
import { useDispatch, useSelector } from 'react-redux'
import { ClearInputs } from '../../../../store/reducers/ScanReducer/RegistrationScanReducer'
import { cardClean } from '../../../../store/reducers/LaborantReducer/LaborantReducer'
import { cassetsFormCreation } from '../../../../store/reducers/LaborantReducer/Form'
import TablePrint from '../../../TablePrint'
import {clearResults} from "../../../../store/reducers/ResultsReducer/ResultsReducer";
import { toast } from 'react-toastify'
import PreScannedPage from '../../../PreScannedPage'

const ScanPage = () => {

    const form = useSelector(state=>state.RegScan.ScanInputs)
    const checkFormInputs = useSelector(state=>state.RegScan.scanCompleted)
    const [scan, setScan] = useState(true)
    const [role, setRole] = useState(true)
    const [finished, setFinished] = useState(false)
    const checkLabForm = useSelector(state=>state.labFormOutput.formCompleted)
    const [number, setNumbers] = useState()
    const resultCopmpleted = useSelector(state=>state.ResultsSlice.isCompleted)
    const checkStatus = useSelector(state=>state.RegScan.ScanInputs.status)
    const [labels, setLabels] = useState([])
    const [print, setPrint] = useState(false)
    const perm = useSelector(state=>state.login.userInfo.permissions.scaning_print)
    const admin = useSelector(state=>state.login.userInfo.role)

    const navigate = useNavigate()
    const dispatch = useDispatch()


    useEffect(()=>{
        if(!perm && admin !== 'admin'){
            setRole(false)
        }
        if(checkStatus == "registered"){
            if(form.research === 'CISH'){
                let arr = []
                let quant = form.quantityMaterial
                for(let i =0; i < quant; i++){
                    arr.push({
                        "label": form
                    })
                }
                setLabels(arr)
                setScan(false)
            } else if (form.research === 'Гістологія'){
                dispatch(cassetsFormCreation(form.quantityMaterial))  
                setScan(false)
            } else if (form.research === 'ІГХ') {
                let arr = []
                let quant = form.quantityMaterial
                for(let i =0; i < quant; i++){
                    arr.push({
                        "label": form
                    })
                }
                setLabels(arr)
                setScan(false)
            } else if (form.research === 'Експрес'){
                setScan(false)
            }
        } else if (checkStatus == "scanAfterForm" && role){
            let arr = []
            let quant = form.quantityMaterial
            for(let i =0; i < quant; i++){
                arr.push({
                    "label": form
                })
            }
            setLabels(arr)
            setScan(false)
        } else if (checkStatus == "scanBeforePaint" && role || checkStatus == "scanAfterPaint" && role) {
            let arr = []
            let quant = form.quantityMaterial
            for(let i =0; i < quant; i++){
                arr.push({
                    "label": form
                })
            }
            setLabels(arr)
            setScan(false)
        } else if (checkStatus == "toDoctor" ){
            toast.error('Скельця направлені до лікаря')
        } else if (checkStatus == "finished"){
            toast.error('Лікар сформував висновок та завершив дослідження!')
            navigate(`/PatientCard/${form.id}`)
        } else if (checkStatus !== "registered" && !role){toast.error('В доступі відмовлено!')}
    },[form])

    useEffect(()=>{
        if(checkLabForm){
            setFinished(checkLabForm)
            setNumbers(form.quantityMaterial)
        }
    },[checkLabForm])

    useEffect(()=>{
        if(resultCopmpleted){
            setFinished(false)
            setScan(true)
            dispatch(ClearInputs())
            dispatch(cardClean())
            dispatch(clearResults())
        }
    },[resultCopmpleted])

    const closePrint = () => {
        setPrint(false)
        setNumbers(form.quantityMaterial)
    }

    const NavToForm = () =>{
        navigate('/LaborantForm')
    }

    const ToFinnished = () =>{
        setPrint(true)
        setFinished(true)
    }

    const CheckedDirection = () =>{
        if (checkStatus == "scanBeforePaint" || checkStatus == "scanAfterPaint" || checkStatus == "scanAfterForm") {
            ToFinnished()
        } else if (checkStatus == "registered") {
            if (form.research === 'CISH' || form.research === 'ІГХ'){
               ToFinnished() 
            } else if (form.research === 'Гістологія' || form.research === 'Експрес'){
                NavToForm()
            }

        }
    }

    return (
        <div className={classes.container}>
            {scan && <Scan/> || finished && !print && <ScanFinished numbers={number}/>}
            {print && <TablePrint onClose={closePrint} labels={labels}/>}
            {!scan && !finished && <PreScannedPage onClose={CheckedDirection} input={form.id}/>}
        </div>
    )
}


export default ScanPage